module.exports = __webpack_public_path__ + "media/add_colleague.a677055f.mp4";